document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".tev-compare");
  if (!section) return;

  const sectionId = section.id.replace("tev-compare-", "");

  const periodEl = document.getElementById(`tev-period-${sectionId}`);
  const mileageEl = document.getElementById(`tev-mileage-${sectionId}`);
  const ageEl = document.getElementById(`tev-age-${sectionId}`);
  const evEl = document.getElementById(`tev-ev-${sectionId}`);
  const fuelEl = document.getElementById(`tev-fuel-${sectionId}`);
  const runEl = document.getElementById(`tev-run-${sectionId}`);
  const resultsEl = document.getElementById(`tev-results-${sectionId}`);

  if (!periodEl || !mileageEl || !ageEl || !evEl || !fuelEl || !runEl || !resultsEl) return;

  if (
    !window.TEV_EV_DATA ||
    !window.TEV_ICE_DATA ||
    !window.TEV_PAIRINGS ||
    !window.TEV_CONFIG ||
    !window.TEV_MAINTENANCE
  ) {
    resultsEl.innerHTML = "<p>Data files are missing.</p>";
    return;
  }

  function formatGBP(value) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Number(value || 0));
  }

  function formatGBPPerMile(value) {
    return `£${Number(value || 0).toFixed(2)}`;
  }

  function getEvById(id) {
    return window.TEV_EV_DATA.find(item => item.id === id) || null;
  }

  function getIceById(id) {
    return window.TEV_ICE_DATA.find(item => item.id === id) || null;
  }

  function getPairing(evId) {
    return window.TEV_PAIRINGS.find(item => item.ev_id === evId) || null;
  }

  function getMaintenanceBand(bandId) {
    return window.TEV_MAINTENANCE.find(item => item.band_id === bandId) || null;
  }

  function getPurchasePrice(pricing, purchaseAge) {
    if (!pricing) return 0;

    if (purchaseAge === "new") return pricing.new_price_gbp ?? 0;
    if (purchaseAge === "2_4") return pricing.used_price_bands_gbp?.["2_4"] ?? pricing.new_price_gbp ?? 0;
    if (purchaseAge === "5_7") return pricing.used_price_bands_gbp?.["5_7"] ?? pricing.used_price_bands_gbp?.["2_4"] ?? pricing.new_price_gbp ?? 0;
    if (purchaseAge === "8_10") return pricing.used_price_bands_gbp?.["8_10"] ?? pricing.used_price_bands_gbp?.["5_7"] ?? pricing.used_price_bands_gbp?.["2_4"] ?? pricing.new_price_gbp ?? 0;

    return pricing.new_price_gbp ?? 0;
  }

  function getStartingAgeYear(purchaseAge) {
    if (purchaseAge === "new") return 1;
    if (purchaseAge === "2_4") return 3;
    if (purchaseAge === "5_7") return 6;
    if (purchaseAge === "8_10") return 9;
    return 1;
  }

  function getAnnualEvEnergyCost(ev, annualMiles) {
    const kwhPerMile = ev.efficiency?.estimated_kwh_per_mile ?? 0;
    const electricityPrice = window.TEV_CONFIG.energy_prices?.home_electricity_per_kwh ?? 0;
    return annualMiles * kwhPerMile * electricityPrice;
  }

  function getAnnualIceFuelCost(ice, annualMiles) {
    const mpg = ice.efficiency?.combined_mpg_uk ?? 0;
    if (!mpg) return 0;

    const litresPerMile = 4.54609 / mpg;
    const fuelPrice =
      ice.fuel_type === "diesel"
        ? (window.TEV_CONFIG.energy_prices?.diesel_per_litre ?? 0)
        : (window.TEV_CONFIG.energy_prices?.petrol_per_litre ?? 0);

    return annualMiles * litresPerMile * fuelPrice;
  }

  function getAnnualMaintenanceCost(band, vehicleAgeYear) {
    if (!band || !band.annual_costs_gbp) return 0;

    if (vehicleAgeYear <= 4) return band.annual_costs_gbp["0_4_years"] ?? 0;
    if (vehicleAgeYear <= 9) return band.annual_costs_gbp["5_9_years"] ?? 0;
    return band.annual_costs_gbp["10_plus_years"] ?? 0;
  }

  function getPeriodMaintenanceCost(band, yearsOwned, purchaseAge) {
    let total = 0;
    const startingAgeYear = getStartingAgeYear(purchaseAge);

    for (let y = 0; y < yearsOwned; y++) {
      const vehicleAgeYear = startingAgeYear + y;
      total += getAnnualMaintenanceCost(band, vehicleAgeYear);
    }

    return total;
  }

  function getPeriodVedCost(vehicle, years, isEv) {
    if (isEv) {
      let total = 0;

      for (let y = 1; y <= years; y++) {
        if (y === 1) {
          total += window.TEV_CONFIG.ved?.zero_emission_first_year_rate_gbp ?? 0;
        } else {
          total += window.TEV_CONFIG.ved?.standard_annual_rate_gbp ?? 0;
        }
      }

      if (vehicle.cost_links?.expensive_car_applicable_new) {
        total += Math.min(years, window.TEV_CONFIG.ved?.expensive_car_years_applied ?? 0) *
          (window.TEV_CONFIG.ved?.expensive_car_supplement_gbp ?? 0);
      }

      return total;
    }

    return years * (window.TEV_CONFIG.ved?.standard_annual_rate_gbp ?? 0);
  }

  function populateEvOptions() {
    evEl.innerHTML = "";

    window.TEV_EV_DATA.forEach(ev => {
      const option = document.createElement("option");
      option.value = ev.id;
      option.textContent = ev.display_name;
      evEl.appendChild(option);
    });
  }

  function getAgeLabel(value) {
    if (value === "new") return "New";
    if (value === "2_4") return "Used 2–4 years";
    if (value === "5_7") return "Used 5–7 years";
    if (value === "8_10") return "Used 8–10 years";
    return "New";
  }

  function renderComparison() {
    try {
      const years = Number(periodEl.value);
      const annualMiles = Number(mileageEl.value);
      const purchaseAge = ageEl.value;
      const evId = evEl.value;
      const fuelType = fuelEl.value;

      const ev = getEvById(evId);
      const pairing = getPairing(evId);

      if (!ev || !pairing) {
        resultsEl.innerHTML = "<p>Pairing data not found.</p>";
        return;
      }

      let iceId = null;
      if (fuelType === "diesel") {
        iceId = pairing.default_diesel_id;
      } else {
        iceId = pairing.default_petrol_id;
      }

      if (!iceId) {
        resultsEl.innerHTML = "<p>No valid comparison model is available for this fuel type yet.</p>";
        return;
      }

      const ice = getIceById(iceId);

      if (!ice) {
        resultsEl.innerHTML = "<p>Comparison vehicle data not found.</p>";
        return;
      }

      const evPurchase = getPurchasePrice(ev.pricing, purchaseAge);
      const icePurchase = getPurchasePrice(ice.pricing, purchaseAge);

      const evAnnualEnergy = getAnnualEvEnergyCost(ev, annualMiles);
      const iceAnnualFuel = getAnnualIceFuelCost(ice, annualMiles);

      const evEnergyTotal = evAnnualEnergy * years;
      const iceFuelTotal = iceAnnualFuel * years;

      const evMaintBand = getMaintenanceBand(ev.cost_links?.maintenance_band);
      const iceMaintBand = getMaintenanceBand(ice.cost_links?.maintenance_band);

      const evMaintenance = getPeriodMaintenanceCost(evMaintBand, years, purchaseAge);
      const iceMaintenance = getPeriodMaintenanceCost(iceMaintBand, years, purchaseAge);

      const evVed = getPeriodVedCost(ev, years, true);
      const iceVed = getPeriodVedCost(ice, years, false);

      const evRunningTotal = evEnergyTotal + evMaintenance + evVed;
      const iceRunningTotal = iceFuelTotal + iceMaintenance + iceVed;

      const evTotal = evPurchase + evRunningTotal;
      const iceTotal = icePurchase + iceRunningTotal;

      const totalMiles = annualMiles * years;
      const evCostPerMile = totalMiles ? evTotal / totalMiles : 0;
      const iceCostPerMile = totalMiles ? iceTotal / totalMiles : 0;

      const runningSavings = iceRunningTotal - evRunningTotal;
      const totalDifference = iceTotal - evTotal;

      resultsEl.innerHTML = `
        <div class="tev-compare__grid">
          <div class="tev-compare__card">
            <h3>${ev.display_name}</h3>
            <div class="tev-compare__row"><span>Purchase condition</span><strong>${getAgeLabel(purchaseAge)}</strong></div>
            <div class="tev-compare__row"><span>Purchase price</span><strong>${formatGBP(evPurchase)}</strong></div>
            <div class="tev-compare__row"><span>Charging cost (${years}y)</span><strong>${formatGBP(evEnergyTotal)}</strong></div>
            <div class="tev-compare__row"><span>VED (${years}y)</span><strong>${formatGBP(evVed)}</strong></div>
            <div class="tev-compare__row"><span>Maintenance (${years}y)</span><strong>${formatGBP(evMaintenance)}</strong></div>
            <div class="tev-compare__row"><span>Running cost (${years}y)</span><strong>${formatGBP(evRunningTotal)}</strong></div>
            <div class="tev-compare__row"><span>Total ownership (${years}y)</span><strong>${formatGBP(evTotal)}</strong></div>
            <div class="tev-compare__row"><span>Cost per mile</span><strong>${formatGBPPerMile(evCostPerMile)}</strong></div>
          </div>

          <div class="tev-compare__card">
            <h3>${ice.display_name}</h3>
            <div class="tev-compare__row"><span>Purchase condition</span><strong>${getAgeLabel(purchaseAge)}</strong></div>
            <div class="tev-compare__row"><span>Purchase price</span><strong>${formatGBP(icePurchase)}</strong></div>
            <div class="tev-compare__row"><span>Fuel cost (${years}y)</span><strong>${formatGBP(iceFuelTotal)}</strong></div>
            <div class="tev-compare__row"><span>VED (${years}y)</span><strong>${formatGBP(iceVed)}</strong></div>
            <div class="tev-compare__row"><span>Maintenance (${years}y)</span><strong>${formatGBP(iceMaintenance)}</strong></div>
            <div class="tev-compare__row"><span>Running cost (${years}y)</span><strong>${formatGBP(iceRunningTotal)}</strong></div>
            <div class="tev-compare__row"><span>Total ownership (${years}y)</span><strong>${formatGBP(iceTotal)}</strong></div>
            <div class="tev-compare__row"><span>Cost per mile</span><strong>${formatGBPPerMile(iceCostPerMile)}</strong></div>
          </div>
        </div>

        <div class="tev-compare__saving">
          ${
            runningSavings >= 0
              ? `Estimated EV running-cost saving over ${years} year(s): <strong>${formatGBP(runningSavings)}</strong>`
              : `Estimated EV running-cost extra over ${years} year(s): <strong>${formatGBP(Math.abs(runningSavings))}</strong>`
          }
        </div>

        <div class="tev-compare__saving" style="margin-top:12px;">
          ${
            totalDifference >= 0
              ? `Estimated EV total ownership saving over ${years} year(s): <strong>${formatGBP(totalDifference)}</strong>`
              : `Estimated EV total ownership extra over ${years} year(s): <strong>${formatGBP(Math.abs(totalDifference))}</strong>`
          }
        </div>
      `;
    } catch (error) {
      resultsEl.innerHTML = "<p>The comparison could not be generated. Please check the data files and try again.</p>";
      console.error(error);
    }
  }

  populateEvOptions();
  runEl.addEventListener("click", renderComparison);
});